import { ArchieveFileCategory } from './ArchieveFileCategory'

export interface BBLDocumentQueryModel {
  take: number
  skip: number
  searchText?: string
  sortColumn?: string
  standardDocument?: boolean
  documentTypeId?: string
  startDate?: string
  endDate?: string
  standard?: boolean
  mimeTypes?: string[]
  sharedWithBbl?: BoardDocumentFilterSharedWithBblEnum
}

export interface BoardDocumentQueryModel {
  take: number
  skip: number
  searchText?: string
  sortColumn?: string
  standardDocument?: boolean
  documentTypeId?: string
  updatedFrom?: string
  updatedTo?: string
  createdTo?: string
  createdFrom?: string
  standard?: boolean
  mimeTypes?: string[]
  sharedWithBbl?: BoardDocumentFilterSharedWithBblEnum
  labelIds?: string[]
  unitIds?: string[]
  fileTypeFilters?: ArchieveFileCategory[]
}

export enum BoardDocumentFilterSharedWithBblEnum {
  Unfiltered = 'Unfiltered',
  ShowOnlyShared = 'ShowOnlyShared',
}
